/* eslint-disable no-shadow */
import { ClassificationType, Color, GeoJsonDataSource, Resource } from 'cesium';
import { getGeom } from '@turf/invariant';
import bboxPolygon from '@turf/bbox-polygon';

const tjClient = require('topojson-client');

export async function loadGeo(layerId, data) {
	const cesiumViewer = this.getCesiumData().viewer;
	const { canvas, camera } = cesiumViewer;
	const url = `${this.axios.defaults.baseURL}files/${data.uri}`;
	const headers = this.axios.defaults.headers.common;
	const loadUrl = new Resource({
		url,
		headers,
		retryAttempts: 10,
	});
	
	const dataSource = await GeoJsonDataSource.load(loadUrl, {
		canvas,
		camera,
		clampToGround: true,
	});

	const geometryTypes = [
		'billboard',
		'box',
		'corridor',
		'cylinder',
		'ellipse',
		'ellipsoid',
		'path',
		'plane',
		'point',
		'polygon',
		'polyline',
		'polylineVolume',
		'rectangle',
		'wall',
	];
	cesiumViewer.entities.suspendEvents();
	// eslint-disable-next-line array-callback-return
	dataSource.entities.values.map((entity, index) => {
		const geometryType = geometryTypes
			.map((types) => (entity[types] ? types : undefined))
			.filter((type) => type)[0];
		entity[geometryType].classificationType = ClassificationType.TERRAIN;
		if (entity.properties) {
			entity.properties = data.properties[index];
		}
		if (entity.properties && entity.properties.color) {
			const colorArray = entity.properties.color
				.valueOf()
				.split(',')
				.map((y) => y / 255);

			const [red, green, blue, alpha] = colorArray;

			const color = new Color(red, green, blue, alpha);

			entity[geometryType].material = color;
		}
		entity.addProperty('layer');
		entity.layer = layerId;
		if (entity[geometryType].material) {
			cesiumViewer.entities.add(entity);
		}
	});
	cesiumViewer.entities.resumeEvents();
	cesiumViewer.scene.requestRender();
}

export async function importGeoFile(file) {
	if (!file.id) throw new Error();
	const { name, id } = file;
	const geoFile = await this.axios.get(`files/${id}`);
	const geometry = getGeom(
		bboxPolygon(tjClient.bbox(geoFile.data))
	);
	const properties =
		geoFile.data.objects.importedGeometry.geometries[0].properties
			.collectedProperties;
	const metadata = {
		type: 'json',
		filterProperty: null,
		uri: id,
		name,
		geometry,
		properties,
		propertyNames: [],
		propertyFilters: {},
	};
	const propertyObj = {};

	const propertyNames = Array.from(
		new Set(properties.map(Object.keys).flat(Infinity))
	);
	if (propertyNames.length) {
		metadata.propertyNames = propertyNames;
		propertyNames.forEach((prop) => {
			propertyObj[prop] = Array.from(
				new Set(properties.map((x) => x[prop]))
			);
		});
		metadata.propertyFilters = propertyObj;
	}

	if (!propertyNames.includes('color')) {
		metadata.properties.forEach(
			// eslint-disable-next-line no-return-assign
			(propertyObj) => (propertyObj.color = '255,0,255,200')
		);
	}

	return  metadata;
}
